var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M4.125 6.216a1.98 1.98 0 0 1 .077 1.355l4.495 2.64a2.2 2.2 0 0 1 1.16-.329c1.183 0 2.143.922 2.143 2.06C12 13.077 11.04 14 9.856 14c-1.183 0-2.143-.922-2.143-2.059 0-.42.132-.81.356-1.135L3.803 8.3a2.17 2.17 0 0 1-1.661.759C.959 9.059 0 8.137 0 7s.96-2.059 2.142-2.059c.586 0 1.117.227 1.504.592l4.271-2.596a1.983 1.983 0 0 1-.204-.878C7.713.922 8.673 0 9.856 0 11.04 0 12 .922 12 2.059s-.96 2.059-2.144 2.059a2.19 2.19 0 0 1-1.424-.52L4.125 6.215z"
  })));
};

export default SvgShare;